export default __webpack_public_path__ + "static/media/advisory.6cf1c735.jpg";